  <form [formGroup]="userForm" class="space-y-4 mt-2" (submit)="save()">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Nome</label>
        <input pInputText formControlName="firstName" class="w-full" />
      </p-float-label>

      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Cognome</label>
        <input pInputText formControlName="lastName" class="w-full" />
      </p-float-label>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Username</label>
        <input pInputText formControlName="username" class="w-full" />
      </p-float-label>

      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Email</label>
        <input pInputText formControlName="email" class="w-full" />
      </p-float-label>
    </div>

    <p-floatlabel class="w-full" variant="on">
      <p-select
        inputId="role"
        formControlName="roleId"
        [options]="roles"
        optionLabel="name"
        optionValue="id"
        placeholder="Seleziona Ruolo"
        class="w-full"
      ></p-select>
      <label for="role">Ruolo</label>
    </p-floatlabel>

    <app-password-fields [group]="userForm" />

    @if (isOperatorSelected()){
      <div class="flex items-center">
        <p-checkbox
          inputId="allowSelfAssignment"
          formControlName="allowSelfAssignment"
          binary="true">
        </p-checkbox>
        <div class="flex flex-col ml-3">
          <label for="allowSelfAssignment">
            Consenti Autoassegnazione
          </label>
            <small>Questo utente avrà la possibilità di vedere la lista delle conversazioni non assegnate e potrà prenderle in carico.</small>
        </div>
      </div>
    }



    <div class="flex justify-end gap-2">
      <p-button label="Cancella" icon="pi pi-times-circle" size="small" severity="secondary" (click)="closeDialog()"/>
      <p-button label="Salva" icon="pi pi-check-circle" size="small" [disabled]="!userForm.valid" type="submit"/>
    </div>
  </form>
